var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDuration = function SvgDuration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47446 7.14113C1.26377 8.74089 1.65355 10.3619 2.56883 11.6922C3.48411 13.0226 4.86022 13.9683 6.43244 14.3475C8.00466 14.7267 9.66192 14.5126 11.0854 13.7463C12.5089 12.9801 13.598 11.7158 14.1433 10.1967C14.6886 8.67768 14.6515 7.01113 14.0392 5.51771C13.4268 4.02429 12.2825 2.80949 10.8263 2.107C9.37015 1.40452 7.70499 1.26398 6.1512 1.71242C4.82384 2.09551 3.65784 2.88531 2.81305 3.96119",
    stroke: "#141414",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63074 0.972656L2.57377 4.29438L5.90377 4.3512",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6991 6.3999V8.40489C7.6991 8.60113 7.81389 8.77923 7.99262 8.86026L9.62387 9.5999",
    stroke: "#141414",
    strokeLinecap: "round"
  })));
};
export default SvgDuration;